(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["escape-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('es-quotes-carousel')) {
  customElements.define(
    'es-quotes-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.querySelectorAll('[data-dir]').forEach((btn) => {
          btn.addEventListener('click', () => this.go(Number(btn.dataset.dir)));
        });
      }
      go(dir) {
        const card = this.track?.querySelector('.es-quotes__card');
        const step = (card?.offsetWidth || 280) + 16;
        this.track?.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
